import { Component } from '@angular/core';
import { FacturaDatos, ProductoDatos } from 'src/app/models/empresa-facturas.interface';
import { EmpresaService } from 'src/app/services/empresa.service';
import { AuthService } from 'src/app/services/auth.service';
const ADMINISTRADOR = 1;
const EMPRESA = 2;
@Component({
  selector: 'app-factura-lst',
  templateUrl: './factura-lst.component.html',
  styleUrls: ['./factura-lst.component.scss']
})
export class FacturaLstComponent {

  public db: FacturaDatos[] = [];

  constructor(private authService: AuthService, private empresaService: EmpresaService) { this.load() }

  load(): void {

    if (this.authService.Session?.id) {

      if (this.authService.Session?.fk_rol == EMPRESA) this.empresaService
        .empresaFacturas(this.authService.Session?.id)
        .subscribe({
          next: (resp) => {
            this.db = resp.datos.facturas;

          }, error: (err) => { console.error(err.error.message) }
        });
      if (this.authService.Session?.fk_rol == ADMINISTRADOR) this.empresaService
        .facturas()
        .subscribe({ next: (resp) => { this.db = resp.datos; }, error: (err) => { console.error(err.error.message) } });
    }

  }

  trackByFactura(index: number, item: FacturaDatos) {
    return item.id;
  }
  trackByProducto(index: number, item: ProductoDatos) {
    return item.id;
  }

}
